module.exports = __webpack_public_path__ + "static/media/momo.d9829490.jpg";